import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { parseWidgetData } from "./parser"
import { keysToCamel } from "@lib/snakeTocamel"
import { updateProductMetaData } from "@containers/App/reducer.js"

const initialState = {
    isLoading: false,
    error: null,
    modalName: null,
}
export const error400 = {
    is_success: false,
    status_code: 400,
    error: {
        message: "Invalid request",
        errors: [
            {
                message: "Invalid request",
            },
        ],
    },
    meta: {
        redirect_status_code: 302,
        redirect_url: "/subscription-plan/subscriptions",
        preserve_query_params: true,
    },
}

export const savingsPageSlice = createSlice({
    name: "savingsPage",
    initialState: initialState,
    reducers: {
        setModalName(state, action) {
            state.modalName = action.payload
        },
        setDefaultData() {
            return initialState
        },
    },
    extraReducers: (builder) => {
        //handle asynchronous actions
        builder.addCase(fetchSavingsData.fulfilled, (state, action) => {
            ;(state.isLoading = false), (state.savingsPageData = parseWidgetData({ data: action?.payload }))
            state.isFetched = true
        }),
            builder.addCase(fetchSavingsData.pending, (state) => {
                state.isLoading = true
            }),
            builder.addCase(fetchSavingsData.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload?.status_code === 400 ? error400 : action.payload
            }),
            builder.addCase(cancelMembership.fulfilled, (state, action) => {
                state.modalName = action.payload
            }),
            builder.addCase(cancelMembership.rejected, (state) => {
                state.modalName = "error_popup"
            }),
            builder.addCase(fetchSavingsBreakdown.fulfilled, (state, action) => {
                state.savingsBreakdownData = keysToCamel(action.payload)
                state.modalName = "detailed_savings"
            }),
            builder.addCase(fetchSavingsBreakdown.rejected, (state) => {
                state.modalName = "error_popup"
            }),
            builder.addCase(setSaleReminder.pending, (state) => {
                state.saleReminderLoading = true
            }),
            builder.addCase(setSaleReminder.fulfilled, (state) => {
                state.saleReminderSuccess = true
            }),
            builder.addCase(setSaleReminder.rejected, (state) => {
                state.modalName = "error_popup"
            })

        builder.addCase(partnershipNotify.pending, (state) => {
            state.partnershipNotifySuccess = true
        })
        builder.addCase(partnershipNotify.fulfilled, (state) => {
            state.partnershipNotifySuccess = true
        })
    },
})

export const fetchSavingsData = createAsyncThunk(
    "savingsPage/fetchData",
    async (_arg, { extra, dispatch, rejectWithValue }) => {
        const { api } = extra
        const { queryParams } = _arg || {}
        const onServer = typeof window === "undefined"
        try {
            const res = await api.get("/api/v4/savings", { params: queryParams })
            if (res?.data?.page_properties && !onServer) {
                const { slug } = res?.data?.page_properties || {}
                if (slug) {
                    window.location.href = slug
                }
            }
            if (res?.data?.meta_data) {
                dispatch(
                    updateProductMetaData({
                        title: res.data.meta_data?.title,
                        description: res.data.meta_data?.description,
                    })
                )
            }
            return Promise.resolve(res.data)
        } catch (err) {
            const onServer = typeof window === "undefined"
            if (!onServer && (err.status_code === 400 || err.status_code === 401))
                window.location.href = "/subscription-plan/subscriptions"
            return rejectWithValue(err)
        }
    }
)

export const partnershipNotify = createAsyncThunk(
    "savingsPage/partnershipNotify",
    async (_arg, { extra, rejectWithValue }) => {
        const { api } = extra

        try {
            const res = await api.put(`api/v4/partnerships/partnership_reminder_set`)
            return Promise.resolve(res)
        } catch (err) {
            return rejectWithValue(err)
        }
    }
)

export const cancelMembership = createAsyncThunk(
    "savingsPage/cancelMembership",
    async ({ planId, cancellationReason, modalName }, { extra }) => {
        const { api } = extra
        await api.post(`/api/v4/subscriptions/cancel`, {
            cancellation_reason: cancellationReason,
            cancellation_type: "subscription",
            plan_name: planId,
        })
        return modalName
    }
)

export const fetchSavingsBreakdown = createAsyncThunk(
    "savingsPage/fetchSavingsBreakdown",
    async (_arg, { extra }) => {
        const { api } = extra
        const res = await api.get("/api/v4/detailed_savings")
        return res.data
    }
)

export const setSaleReminder = createAsyncThunk("savingsPage/setSaleReminder", async (_arg, { extra }) => {
    const { api } = extra
    const res = await api.get("/api/v4/set_reminder")
    return res.data
})

export const savingsPageReducer = savingsPageSlice.reducer

export const { setModalName, setDefaultData } = savingsPageSlice.actions
